import UsersPage from './Users.container';

export default UsersPage;
